<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_gameWithTime') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='gameTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                        v-model='selectedGameType',
                        @select='params.options = $event'
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_viewTypeLeft') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='viewTypesExample',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseViewType')",
                        v-model='leftColumnViewExample',
                        @select='params.leftColumnExample = $event.type'
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.amountOfPairs",
                        :max="amountOfPairs",
                        :min="3",
                        @increase="increaseAmountOfPairs",
                        @decrease="decreaseAmountOfPairs",
                        @input="params.amountOfPairs = $event",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.numOfExamples",
                        :max="numOfExamples",
                        :min="1",
                        @increase="increaseNumOfExamples",
                        @decrease="decreaseNumOfExamples",
                        @input="params.numOfExamples = $event",
                    )
            .form__field(v-if="params.withTime && gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_pairShowTime') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds"
                        v-model="params.showTime"
                        :placeholder="secondsLabel(params.showTime)"
                        :custom-label="secondsLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            divider
            .row(:style="{'margin-bottom': '10px'}")
                .col-md-11.col-xs-12
                    .divisible-multiplier
                        span
                            template(v-if='params.numbers.length  ===  0')
                                |   {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')  }}
                            template(v-else='')
                                |   {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}
                    .form__field_columns.form__field_numbers
                        template(v-for='(number, index) in numbers')
                            cs-checkbox.checkbox-for-numbers(
                                :checked="params.numbers && params.numbers.includes(number)",
                                @change="setNumber(number)"
                                :disabled="params.options && params.options.division && number === 0"
                            )
                                |   {{ number }}
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="disableSaveButton")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="disableSaveButton")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="disableSaveButton")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _ from "lodash";
    import IntervalConfig from "../../trainer/configs/IntervalConfig";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                gameTypes: [
                    {
                        name: this.$i18n.t('common.common_gameName_multiplicationWithoutTime'),
                        multiplication: true,
                        division: false,
                        withTime: false,
                    },
                    {
                        name: this.$i18n.t('common.common_gameName_multiplicationWithTime'),
                        multiplication: true,
                        division: false,
                        withTime: true,
                    },
                    {
                        name: this.$i18n.t('common.common_gameName_divisionWithoutTime'),
                        multiplication: false,
                        division: true,
                        withTime: false,
                    },
                    {
                        name: this.$i18n.t('common.common_gameName_divisionWithTime'),
                        multiplication: false,
                        division: true,
                        withTime: true,
                    }
                ],
                gameModes: [
                    {
                        name: this.$i18n.t('couples.couples_gameMode_allTogether'),
                        mode: 'allTogether'
                    },
                ],
                viewTypes: [
                    {
                        name: this.$i18n.t('couples.couples_view_images'),
                        type: 'image'
                    },
                ],
                amountOfPairs: 20,
                numOfExamples: 100,
                seconds: IntervalConfig.secondsForMemoryGames,
                selectedGameType: null,
                rightColumnView: null,
                leftColumnView: null,
                leftColumnViewExample: null,
                selectedGameMode: null,
                params: null,
            }
        },
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.leftColumnViewExample = _.find(this.viewTypesExample, {type: this.params.leftColumnExample} );
            this.rightColumnView = _.find(this.viewTypes, { type: this.params.rightColumn });
            this.leftColumnView = _.find(this.viewTypes, { type: this.params.leftColumn });
        },
        updated () {
            this.rightColumnView = _.find(this.viewTypes, { type: this.params.rightColumn });
            this.leftColumnView = _.find(this.viewTypes, { type: this.params.leftColumn });
            if (this.params?.withTime) {
                this.params.mode = 'inTurn';
            } else {
                this.params.mode = 'allTogether';
            }
        },
        watch: {
            'params.withTime'(val) {
                if (val) {
                    this.params.showTime = this.seconds[0];
                } else {
                    this.params.showTime = null;
                }
            },
            'params.options'(val, oldVal) {
                if (val) {
                    this.params.withTime = val.withTime
                    this.selectedGameType = val
                }
                if (oldVal && val !== oldVal) {
                    this.leftColumnViewExample = null
                }
               if (val?.division && this.params.numbers.includes(0)) {
                   this.params.numbers.splice(this.params.numbers.indexOf(0), 1)
               }

            }
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            numbers() {
                return Array.from(Array(11), (_, i) => i);
            },
            disableSaveButton() {
                return !(this.selectedGameType && this.leftColumnViewExample)
            },
            viewTypesExample() {
                if (this.params.options) {
                    if (this.params.options.multiplication) {
                        return [
                            {
                                name: this.$i18n.t('trainer.trainer_gameFormSetting_multipliers'),
                                type: 'multipliers'
                            },
                            {
                                name: this.$i18n.t('trainer.trainer_gameFormSetting_product'),
                                type: 'product'
                            },
                        ]
                    } else {
                        return [
                            {
                                name: this.$i18n.t('trainer.trainer_gameFormSetting_divider'),
                                type: 'divider'
                            },
                            {
                                name: this.$i18n.t('trainer.trainer_gameFormSetting_quotient'),
                                type: 'quotient'
                            },
                        ]
                    }

                } else {
                    return [];
                }
            }

        },
        methods: {
            setNumber(number) {
                if (this.params.numbers.includes(number)) {
                    this.params.numbers.splice(this.params.numbers.indexOf(number), 1);
                } else {
                    this.params.numbers.push(number);
                }
            },
            secondsLabel (second) {
                if (second) {
                    return second + " " + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds')
                } else {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_select')
                }
            },
            decreaseAmountOfPairs() {
                if (this.params.amountOfPairs !== 1) {
                    this.params.amountOfPairs -= 1;
                }
            },
            increaseAmountOfPairs() {
                if (this.params.amountOfPairs !== this.amountOfPairs) {
                    this.params.amountOfPairs += 1;
                }
            },
            decreaseNumOfExamples() {
                if (this.params.numOfExamples !== 1) {
                    this.params.numOfExamples -= 1;
                }
            },
            increaseNumOfExamples() {
                if (this.params.numOfExamples !== this.numOfExamples) {
                    this.params.numOfExamples += 1;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .divisible-multiplier {
        margin: 10px 5px;
    }

    .checkbox-for-numbers {
        margin-right: 15px;
        margin-bottom: $space-small !important;
    }

    .form__field_columns {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
    }

    .form__field_numbers {
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 0;
    }

    .form__field--column {
        flex-direction: column;
        @include stack-space($space-base);
        align-items: flex-start;
    }

    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

